module.exports = __webpack_public_path__ + "img/cuff buttons quantity.b9679125.png";